import { render, staticRenderFns } from "./ExternalTicketDetail.vue?vue&type=template&id=7977f1f0&"
import script from "./ExternalTicketDetail.vue?vue&type=script&lang=js&"
export * from "./ExternalTicketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports